import { detectBrowser } from "@shared/utils/browserDetection";

export type ReachabilityTelemetryStatus =
  | "reachable"
  | "degraded"
  | "blocked"
  | "unknown";

export type BrowserTelemetryPayload = {
  browser_family?: string;
  browser_major?: number;
};

export function getBrowserTelemetry(): BrowserTelemetryPayload {
  const browser = detectBrowser();
  return {
    browser_family: browser.family,
    ...(typeof browser.major === "number" ? { browser_major: browser.major } : {}),
  };
}
